import React from 'react';

interface ImageItem {
  url: string;
  thumbnail?: string;
  title?: string;
  description?: string;
}

interface ImageWidgetResultProps {
  images: ImageItem[];
  title?: string;
}

const ImageWidgetResult: React.FC<ImageWidgetResultProps> = ({ images, title }) => {
  console.log('ImageWidgetResult render:', { images, title, imageCount: images?.length });
  
  if (!images || images.length === 0) {
    return (
      <div className="space-y-4 p-4">
        {title && (
          <h3 className="text-lg font-semibold text-[var(--rhea-text-primary)]">
            {title}
          </h3>
        )}
        <div className="text-center py-8 text-[var(--rhea-text-secondary)]">
          No images found
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-4 p-4 max-h-[800px] overflow-y-auto">
      {title && (
        <h3 className="text-lg font-semibold text-[var(--rhea-text-primary)]">
          {title}
        </h3>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {images.map((image, index) => {
          console.log(`Image ${index}:`, image);
          return (
            <div key={index} className="bg-[var(--rhea-bg-secondary)] rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-shadow">
              <a href={image.url} target="_blank" rel="noopener noreferrer">
              <div className="relative group">
                <img
                  src={image.thumbnail}
                  alt={image.title || `Image ${index + 1}`}
                  className="w-full h-48 object-cover"
                  onLoad={() => console.log(`Image ${index} loaded successfully:`, image.thumbnail)}
                  onError={(e) => {
                    console.error(`Image ${index} failed to load:`, image.thumbnail);
                    const target = e.target as HTMLImageElement;
                    target.src = 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZjNmNGY2Ii8+PHRleHQgeD0iNTAlIiB5PSI1MCUiIGZvbnQtZmFtaWx5PSJBcmlhbCwgc2Fucy1zZXJpZiIgZm9udC1zaXplPSIxNCIgZmlsbD0iIzk5OWEiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGR5PSIuM2VtIj5JbWFnZTwvdGV4dD48L3N2Zz4=';
                  }}
                />
                {(image.title || image.description) && (
                  <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-50 text-white p-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200">
                    {image.title && (
                      <h4 className="font-semibold text-sm mb-1">{image.title}</h4>
                    )}
                    {image.description && (
                      <p className="text-xs text-gray-200">{image.description}</p>
                    )}
                  </div>
                )}
              </div>
              </a>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ImageWidgetResult;